export function composeTripReferenceKey(recordLocator: string, originCode: string, destinationCode: string): string{
    return `${recordLocator}_${originCode}${destinationCode}`;
}
